import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
// import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
import Select from "react-select"
import ReactQuill from "react-quill";
const address = require('@bangladeshi/bangladesh-address')

// import { divisions, districts, upazilas } from "@bangladeshi/bangladesh-address";
// import divisions from "@bangladeshi/bangladesh-address/dist/divisions.json";
// import districts from "@bangladeshi/bangladesh-address/dist/districts.json";
// import upazilas from "@bangladeshi/bangladesh-address/dist/upazilas.json";
//toast.configure({ autoClose: 2000 })
const Create = () => {
    const [error, setError] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [faqs, setFaqs] = useState([]);
    const [newFaq, setNewFaq] = useState({ question: "", answer: "" });
    const [district, setDistrict] = useState();

    // const rawDivisions = address.allDivision();
    // const all_Divisions = rawDivisions.map(div => ({
    //         value: div,
    //         label: div
    //     }));
    
    const rawDistict = address.allDistict();
    const all_Distict = rawDistict.map(div => ({
            value: div,
            label: div
        }));

    // const rawupazila = address.allUpazila();
    // const all_upazila = rawupazila.map(div => ({
    //         value: div,
    //         label: div
    //     }));
    
    // console.log(all_upazila);
    
// const [selectedDivision, setSelectedDivision] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");

//   const filteredDistricts = districts.filter(
//     (d) => d.division_id === Number(selectedDivision)
//   );

//   const filteredUpazilas = upazilas.filter(
//     (u) => u.district_id === Number(selectedDistrict)
//   );

    // ✅ Add FAQ
    const addFaq = () => {
        if (!newFaq.question.trim() || !newFaq.answer.trim()) return alert("Please enter both question and answer!");
        setFaqs([...faqs, newFaq]);
        setNewFaq({ question: "", answer: "" });
    };

    // ✅ Remove FAQ
    const removeFaq = (index) => {
        const updatedFaqs = faqs.filter((_, i) => i !== index);
        setFaqs(updatedFaqs);
    };
    const [lifePartnerIn, setLifePartnerIn] = useState("");

    const handleLifePartnerInChange = (content) => {
        setLifePartnerIn(content);
        
        // if (onChange) onChange(content);
    };

    const [whyChooseProfiles, setWhyChooseProfiles] = useState("");

    const handleWhyChooseProfilesChange = (content) => {
        setWhyChooseProfiles(content);
        
        // if (onChange) onChange(content);
    };

    const [verifiedProfiles, setVerifiedProfiles] = useState("");

    const handleVerifiedProfilesChange = (content) => {
        setVerifiedProfiles(content);
        
        // if (onChange) onChange(content);
    };

    const [popularAreas, setPopularAreas] = useState("");

    const handlePopularAreasChange = (content) => {
        setPopularAreas(content);
        
        // if (onChange) onChange(content);
    };

    const [successStories, setSuccessStories] = useState("");

    const handleSuccessStoriesChange = (content) => {
        setSuccessStories(content);
        
        // if (onChange) onChange(content);
    };

    const [startYourJourney, setStartYourJourney] = useState("");

    const handleStartYourJourneyChange = (content) => {
        setStartYourJourney(content);
        
        // if (onChange) onChange(content);
    };
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const addItem = () => {
        if (inputValue.trim() === "") return;
        setItems([...items, inputValue]);
        setInputValue("");
    };

    const removeItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };

    const [verification, setVerification] = useState([]);
    const [inputVerification, setInputVerification] = useState("");

    const addVerification = () => {
        if (inputVerification.trim() === "") return;
        setVerification([...verification, inputVerification]);
        setInputVerification("");
    };

    const removeVerification = (index) => {
        setItems(verification.filter((_, i) => i !== index));
    };
    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 500) {
                setError({ ...error, image: 'Select less than 300KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setError({ ...errors, image: null })
        }
    }

//       const [divisions, setDivisions] = useState([]);
//   const [districts, setDistricts] = useState([]);
//   const [upazilas, setUpazilas] = useState([]);

//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedUpazila, setSelectedUpazila] = useState("");

  // Load all divisions on component mount
//   useEffect(() => {
//     setDivisions(address.Division.allDivision());
//   }, []);

  // When division changes, load districts
//   useEffect(() => {
//     if (selectedDivision) {
//       setDistricts(address.District.districtOf(selectedDivision));
//       setUpazilas([]); // reset upazilas
//       setSelectedDistrict("");
//       setSelectedUpazila("");
//     }
//   }, [selectedDivision]);

  // When district changes, load upazilas
//   useEffect(() => {
//     if (selectedDivision && selectedDistrict) {
//       const data = address.Division.divisionalDataOf(selectedDivision);
//       const districtData = data.districts.find(d => d.name === selectedDistrict);
//       setUpazilas(districtData ? districtData.upazilas : []);
//       setSelectedUpazila("");
//     }
//   }, [selectedDistrict, selectedDivision]);

    // Submit Form
    const onSubmit = async (data) => {
        try {
            if (!selectedFile) return setError({ ...error, image: 'Image is required' })
                // console.log("district", district);
                
            setLoading(true)
            let formData = new FormData()
            formData.append('metaTitle', data.metaTitle)
            formData.append('metaDescription', data.metaDescription)
            formData.append('title', data.title)
            formData.append('district', district)
            formData.append('areaName', data.areaName)
            formData.append('lifePartnerIn', lifePartnerIn)
            formData.append('whyChooseProfiles', whyChooseProfiles)
            formData.append('verifiedProfiles', verifiedProfiles)
            formData.append('popularAreas', popularAreas)
            formData.append('successStories', successStories)
            formData.append('startYourJourney', startYourJourney)
            formData.append("membersAreKnown", JSON.stringify(items));
            formData.append("verificationProcess", JSON.stringify(verification));
            formData.append("faq", JSON.stringify(faqs));
            formData.append('image', selectedFile.image)

            const response = await Requests.ProfileArea.Store(formData, header)
            if (response) {
                setLoading(false)
                navigate("/dashboard/website/area-profile")
            }


        } catch (error) {
            if (error) console.log(error)
        }
    }

    return (
        <div className="store-blog pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Area Profile</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/blog"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    <div className="row">

                                        {/* Image upload Container */}
                                        <div className="form-group mb-4">
                                            {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                            <div className="d-flex">
                                                {selectedFile && selectedFile.preview ?
                                                    <div className="img-container text-center mr-2">
                                                        <div className="image border">
                                                            <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                        </div>
                                                    </div>
                                                    : null}

                                                <div className="img-container text-center">
                                                    <div className="image border">
                                                        <input type="file" className="upload" onChange={handleImage} />
                                                        <div className="flex-center flex-column">
                                                            <Icon icon={plus} size={22} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/*  Meta Title */}
                                        <div className="col-12">
                                            <div className="form-group mb-4">
                                                {errors.metaTitle && errors.metaTitle.message ? (
                                                    <p className="text-danger">{errors.metaTitle && errors.metaTitle.message}</p>
                                                ) : <p>Meta Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="metaTitle"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Meta Title"
                                                    {...register("metaTitle", { required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* metaDescription */}
                                        <div className="form-group mb-4">
                                            {errors.metaDescription && errors.metaDescription.message ? (
                                                <p className="text-danger">{errors.metaDescription && errors.metaDescription.message}</p>
                                            ) : <p>Meta Description</p>}

                                            <textarea
                                                type="text"
                                                name="metaDescription"
                                                rows={5}
                                                className="form-control shadow-none"
                                                placeholder="Enter Meta Description"
                                                {...register("metaDescription", { required: "Description is required" })}
                                            />
                                        </div>

                                    </div>

                                    <div className='row'>
                                        <div className="col-12 col-lg-12">
                                            <div className="form-group mb-4">
                                                {errors.title && errors.title.message ? (
                                                    <p className="text-danger">{errors.title && errors.title.message}</p>
                                                ) : <p>Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Title"
                                                    {...register("title", { required: "Title is required" })}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            {/* Division */}
                                            {/* <select
                                                value={selectedDivision}
                                                onChange={(e) => {
                                                setSelectedDivision(e.target.value);
                                                setSelectedDistrict(""); // reset district
                                                }}
                                            >
                                                <option value="">Select Division</option>
                                                {divisions.map((div) => (
                                                <option key={div.id} value={div.id}>
                                                    {div.bn_name} 
                                                </option>
                                                ))}
                                            </select> */}

                                            {/* District */}
                                            {/* <select
                                                value={selectedDistrict}
                                                onChange={(e) => setSelectedDistrict(e.target.value)}
                                                disabled={!selectedDivision}
                                            >
                                                <option value="">Select District</option>
                                                {filteredDistricts.map((dist) => (
                                                <option key={dist.id} value={dist.id}>
                                                    {dist.bn_name}
                                                </option>
                                                ))}
                                            </select> */}

                                            {/* Upazila */}
                                            {/* <select disabled={!selectedDistrict}>
                                                <option value="">Select Upazila</option>
                                                {filteredUpazilas.map((upa) => (
                                                <option key={upa.id} value={upa.id}>
                                                    {upa.bn_name}
                                                </option>
                                                ))}
                                            </select> */}
                                        </div>
                                        {/*  District */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>District</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    options={all_Distict}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    onChange={(event) => setDistrict(event.value)}
                                                    menuPortalTarget={document.body}
                                                />

                                                 {/* <select
                                                    value={district}
                                                    onChange={(e) => {
                                                    setDistrict(e.target.value);
                                                    setUpazila("");
                                                    }}
                                                    disabled={!division}
                                                >
                                                    <option value="">Select District</option>
                                                    {filteredDistricts.map((dis) => (
                                                    <option key={dis.id} value={dis.id}>
                                                        {dis.name}
                                                    </option>
                                                    ))}
                                                </select> */}
                                            </div>
                                        </div>
                                        {/*  Area Name */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.areaName && errors.areaName.message ? (
                                                    <p className="text-danger">{errors.areaName && errors.areaName.message}</p>
                                                ) : <p>Area Name</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="areaName"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Area Name"
                                                    {...register("areaName", { required: "Area Name is required" })}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    {/* Find Your Life Partner in */}
                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Find Your Life Partner in</p>

                                        <ReactQuill
                                            value={lifePartnerIn}
                                            onChange={handleLifePartnerInChange}
                                            theme="snow"
                                            rows={5}
                                            className="bg-white"
                                        />
                                    </div>
                                    {/* <div className="form-group mb-4">
                                        {errors.findYourLifePartner && errors.findYourLifePartner.message ? (
                                            <p className="text-danger">{errors.findYourLifePartner && errors.findYourLifePartner.message}</p>
                                        ) : <p>Find Your Life Partner in</p>}

                                        <textarea
                                            type="text"
                                            name="findYourLifePartner"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Find Your Life Partner in"
                                            {...register("findYourLifePartner")}
                                        />
                                    </div> */}


                                    {/* Why Choose Dhaka Profiles? */}
                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Why Choose Dhaka Profiles?</p>

                                        <ReactQuill
                                            value={whyChooseProfiles}
                                            onChange={handleWhyChooseProfilesChange}
                                            theme="snow"
                                            rows={5}
                                            className="bg-white"
                                        />
                                    </div>

                                    {/* Our Dhaka members are known for: */}
                                    <div className="form-group mb-4">
                                        {errors.membersAreKnown && errors.membersAreKnown.message ? (
                                            <p className="text-danger">{errors.membersAreKnown && errors.membersAreKnown.message}</p>
                                        ) : <p>Our members are known for:</p>}

                                        <ul className="list-group mb-3">
                                            {items.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {item}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => removeItem(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>

                                        <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                            <input
                                                type="text"
                                                placeholder="Enter members are known"
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                style={{
                                                    flex: "1",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <div
                                                onClick={addItem}
                                                className='btn btn-sm btn-danger'
                                                // style={{
                                                //     backgroundColor: "#007bff",
                                                //     color: "white",
                                                //     border: "none",
                                                //     borderRadius: "4px",
                                                //     padding: "6px 12px",
                                                //     cursor: "pointer",
                                                // }}
                                            >
                                                Add
                                            </div>
                                        </div>
                                    </div>

                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Verified Profiles You Can Trust</p>

                                        <ReactQuill
                                            value={verifiedProfiles}
                                            onChange={handleVerifiedProfilesChange}
                                            theme="snow"
                                            className="bg-white"
                                        />
                                    </div>

                                    {/* Our verification process includes: */}
                                    <div className="form-group mb-4">
                                        {errors.membersAreKnown && errors.membersAreKnown.message ? (
                                            <p className="text-danger">{errors.membersAreKnown && errors.membersAreKnown.message}</p>
                                        ) : <p>Our verification process includes:</p>}

                                        <ul className="list-group mb-3">
                                            {verification.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {item}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => removeVerification(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>

                                        <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                            <input
                                                type="text"
                                                placeholder="Our verification process includes"
                                                value={inputVerification}
                                                onChange={(e) => setInputVerification(e.target.value)}
                                                style={{
                                                    flex: "1",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <div
                                                onClick={addVerification}
                                                className='btn btn-sm btn-danger'
                                                // style={{
                                                //     backgroundColor: "#007bff",
                                                //     color: "white",
                                                //     border: "none",
                                                //     borderRadius: "4px",
                                                //     padding: "6px 12px",
                                                //     cursor: "pointer",
                                                // }}
                                            >
                                                Add
                                            </div>
                                        </div>
                                    </div>

                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Popular Areas We Cover in</p>

                                        <ReactQuill
                                            value={popularAreas}
                                            onChange={handlePopularAreasChange}
                                            theme="snow"
                                            className="bg-white"
                                        />
                                    </div>

                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Success Stories from</p>

                                        <ReactQuill
                                            value={successStories}
                                            onChange={handleSuccessStoriesChange}
                                            theme="snow"
                                            className="bg-white"
                                        />
                                    </div>

                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Start Your Journey in</p>

                                        <ReactQuill
                                            value={startYourJourney}
                                            onChange={handleStartYourJourneyChange}
                                            theme="snow"
                                            className="bg-white"
                                        />
                                    </div>
                                    {/* <div className="form-group mb-4">
                                        {errors.whyChooseProfiles && errors.whyChooseProfiles.message ? (
                                            <p className="text-danger">{errors.whyChooseProfiles && errors.whyChooseProfiles.message}</p>
                                        ) : <p>Why Choose Dhaka Profiles?</p>}

                                        <textarea
                                            type="text"
                                            name="whyChooseProfiles"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Why Choose Dhaka Profiles?"
                                            {...register("whyChooseProfiles")}
                                        />
                                    </div> */}

                                    {/* Our Dhaka members are known for: */}
                                    <div className="form-group mb-4">
                                        {errors.membersAreKnown && errors.membersAreKnown.message ? (
                                            <p className="text-danger">{errors.membersAreKnown && errors.membersAreKnown.message}</p>
                                        ) : <p>Our Dhaka members are known for:</p>}

                                        <ul className="list-group mb-3">
                                            {items.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {item}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => removeItem(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>

                                        <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                            <input
                                                type="text"
                                                placeholder="Enter members are known"
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                style={{
                                                    flex: "1",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <div
                                                onClick={addItem}
                                                className='btn btn-sm btn-danger'
                                                // style={{
                                                //     backgroundColor: "#007bff",
                                                //     color: "white",
                                                //     border: "none",
                                                //     borderRadius: "4px",
                                                //     padding: "6px 12px",
                                                //     cursor: "pointer",
                                                // }}
                                            >
                                                Add
                                            </div>
                                        </div>
                                    </div>

                                    {/* Verified Profiles You Can Trust */}
                                    {/* <div className="form-group mb-4">
                                        {errors.verifiedProfiles && errors.verifiedProfiles.message ? (
                                            <p className="text-danger">{errors.verifiedProfiles && errors.verifiedProfiles.message}</p>
                                        ) : <p>Verified Profiles You Can Trust</p>}

                                        <textarea
                                            type="text"
                                            name="verifiedProfiles"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Verified Profiles You Can Trust"
                                            {...register("verifiedProfiles")}
                                        />
                                    </div> */}

                                    {/* Popular Areas We Cover in */}
                                    {/* <div className="form-group mb-4">
                                        {errors.popularAreas  && errors.popularAreas.message ? (
                                            <p className="text-danger">{errors.popularAreas && errors.popularAreas.message}</p>
                                        ) : <p>Popular Areas We Cover in </p>}

                                        <textarea
                                            type="text"
                                            name="popularAreas"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Popular Areas We Cover in"
                                            {...register("popularAreas")}
                                        />
                                    </div> */}

                                    {/* Success Stories from */}
                                    {/* <div className="form-group mb-4">
                                        {errors.successStories && errors.successStories.message ? (
                                            <p className="text-danger">{errors.successStories && errors.successStories.message}</p>
                                        ) : <p>Success Stories from </p>}

                                        <textarea
                                            type="text"
                                            name="successStories"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Success Stories from"
                                            {...register("successStories", )}
                                        />
                                    </div> */}

                                    {/* Start Your Journey in*/}
                                    {/* <div className="form-group mb-4">
                                        {errors.startYourJourneyIn && errors.startYourJourneyIn.message ? (
                                            <p className="text-danger">{errors.startYourJourneyIn && errors.startYourJourneyIn.message}</p>
                                        ) : <p>Start Your Journey in </p>}

                                        <textarea
                                            type="text"
                                            name="startYourJourneyIn"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Start Your Journey in"
                                            {...register("startYourJourneyIn")}
                                        />
                                    </div> */}

                                    {/* FAQ*/}
                                    <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>FAQ </p>}

                                        {faqs.length > 0 ? (
                                            faqs.map((faq, index) => (
                                                <div key={index} className="border rounded p-3 mb-3 bg-light">
                                                    <h6 className="fw-semibold mb-2">
                                                        {index + 1}. {faq.question}
                                                    </h6>
                                                    <p className="mb-2">{faq.answer}</p>
                                                    <div className='flex justify-content-end'>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => removeFaq(index)}
                                                    >
                                                        Remove
                                                    </button></div>
                                                </div>
                                            ))
                                        ) : (<p></p>
                                            // <p className="text-muted">No FAQs added yet.</p>
                                        )}

                                        {/* ✅ Add New FAQ */}
                                        <div className="border rounded p-3 bg-white">
                                            <h6 className="fw-semibold mb-3">Add New FAQ</h6>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Enter question"
                                                value={newFaq.question}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, question: e.target.value })
                                                }
                                            />
                                            <textarea
                                                className="form-control mb-2"
                                                rows={3}
                                                placeholder="Enter answer"
                                                value={newFaq.answer}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, answer: e.target.value })
                                                }
                                            />
                                            <div className="btn btn-success" onClick={addFaq}>
                                                Add FAQ
                                            </div>
                                        </div>
                                    </div>



                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Creating...' : 'Create'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        height: 40,
        fontSize: 13,
        color: "#000",
        minWidth: 170,
        boxShadow: "none",
        "&:hover": { borderColor: "1px solid #ced4da" },
        border: state.isFocused ? "1px solid #dfdfdf" : "1px solid #ced4da",
        borderRadius: 0,
        menuPortal: base => ({ ...base, zIndex: 999 })
    }),
};